class CustomWebsocket extends WebSocket {
    constructor(url) {
        super(url);

        this.eventListeners = {}; // Event listeners for this websocket

        // When we receive a message from the websocket parse it and emit relevant event
        this.onmessage = (message) => {
            const msg = this.read(message);
            this.emit(msg.type, msg.data);
        };
    }

    /**
     * Register a new event listener
     * @param {String, Array} name - The name of the event we're listening for
     * @param {Function} callback - The function to run when the event is called
     */
    on(name, callback) {
        const names = Array.isArray(name) ? name : [name]; // Transform to array

        names.forEach((name) => {
            if (!this.eventListeners[name]) {
                this.eventListeners[name] = []; // If the event is not defined, define it as empty array
            }

            this.eventListeners[name].push(callback); // Assign the callback function
        });
    }

    /**
     * Emit a new event
     * @param {String} name - The name of the event we're emitting
     * @param {Function} data - The data we're sending
     */
    emit(name, data) {
        if (!this.eventListeners[name]) {
            const errormsg = `Can't emit an event. Event "${name}" doesn't exits.`;
            throw new Error(errormsg);
        }

        const fireCallbacks = (callback) => {
            callback(data);
        };

        this.eventListeners[name].forEach(fireCallbacks);
    }

    /**
     * Send command and payload to server as JSON
     * @param {String} command - The name of the command
     * @param {Object} payload - The payload
     */
    write(command, payload = {}) {
        this.send(
            JSON.stringify({
                command: command,
                data: payload,
            }),
        );
    }

    /**
     * Read message from server and parse
     * @param {Object} payload - The payload
     */
    read(payload) {
        return JSON.parse(payload.data);
    }
}
export default CustomWebsocket;
